import axios from "axios";

const baseURL = import.meta.env.VITE_APP_API_SERVER || window.location.origin;

export const baseApi = axios.create({
  baseURL,
});
